import { render, staticRenderFns } from "./header-desktop.vue?vue&type=template&id=3b8a963f&scoped=true&"
import script from "./header-desktop.vue?vue&type=script&lang=js&"
export * from "./header-desktop.vue?vue&type=script&lang=js&"
import style0 from "./header-desktop.vue?vue&type=style&index=0&id=3b8a963f&prod&lang=scss&"
import style1 from "./header-desktop.vue?vue&type=style&index=1&id=3b8a963f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a963f",
  null
  
)

export default component.exports